import { PropsWithChildren } from 'react'
import { TenantContext, TenantContextType } from './TenantContext'
import { useQuery } from '@based/sdk/react'
import { ViewTenantModel } from 'functions/tenant/steunpunt-amsterdam/view'

export const TenantContextProvider = (
  props: PropsWithChildren<TenantContextType>,
) => {
  const {
    data: tenant,
    loading,
  }: { data?: ViewTenantModel; loading: boolean } = useQuery(
    'tenant-steunpunt-amsterdam-view',
    {
      id: props.id,
    },
  )

  return (
    <TenantContext.Provider value={{ ...props, tenant, loading }}>
      {props.children}
    </TenantContext.Provider>
  )
}
